import styled from "styled-components";

import { MAX_WIDTH, SIZE, gutter, margin, mediaQuery, pixelate, unit } from '../../../theme/metrics';


export const StyledOuter = styled.div<{ $noSpaceAfter?: boolean, $spaceBefore?: boolean, $extraSpaceBefore?: boolean, $extraSpaceAfter?: boolean }>`
  padding-bottom: ${({ $noSpaceAfter }) => $noSpaceAfter ? `0` : unit(10)};
  padding-top: ${({ $spaceBefore }) => $spaceBefore ? unit(10) : `0`};
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.primary};

  ${mediaQuery[SIZE.medium]} {
    padding-bottom: ${({ $noSpaceAfter }) => $noSpaceAfter ? `0` : unit(20)};
    padding-top: ${({ $spaceBefore }) => $spaceBefore ? unit(20) : `0`};
  }

  ${mediaQuery[SIZE.large]} {
    padding-bottom: ${({ $noSpaceAfter, $extraSpaceAfter }) => $noSpaceAfter ? `0` : $extraSpaceAfter ? unit(40) : unit(20)};
    padding-top: ${({ $spaceBefore, $extraSpaceBefore }) => $spaceBefore ? $extraSpaceBefore ? unit(40) : unit(20) : `0`};
  }
`;

export const StyledInner = styled.div<{ $removeSpaceAfter?: boolean, $mask?: boolean, $relative?: boolean, $removeExtraSpaceAfter?: boolean, $verticalSpace?: "small" | "medium" | "large" }>`
  max-width: ${pixelate(MAX_WIDTH)};
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  ${({ $mask }) => $mask ? `overflow: clip;` : ``}
  ${({ $relative }) => $relative ? `position: relative;` : ``}

  display: grid;
  padding-left: ${margin(SIZE.small)};
	padding-right: ${margin(SIZE.small)};
  column-gap: ${gutter(SIZE.small)};
  grid-auto-flow: dense;
  grid-template-rows: auto;
  grid-template-columns: repeat(12, [col-start] 1fr);

  ${({ $verticalSpace }) => $verticalSpace && `row-gap:${$verticalSpace === "large" ? unit(10) : $verticalSpace === "medium" ? unit(5) : unit(3)}`};

  ${mediaQuery[SIZE.medium]} {
    padding-left: ${margin(SIZE.medium)};
    padding-right: ${margin(SIZE.medium)};
    column-gap: ${gutter(SIZE.medium)};
    // margin-bottom: ${({ $removeSpaceAfter, $removeExtraSpaceAfter }) => $removeSpaceAfter ? $removeExtraSpaceAfter ? unit(-40) : unit(-20) : `0`};
    // margin-bottom: ${({ $removeSpaceAfter, $removeExtraSpaceAfter }) => $removeSpaceAfter ? unit(-20) : `0`};

  }

  ${mediaQuery[SIZE.large]} {
    padding-left: ${margin(SIZE.large)};
    padding-right: ${margin(SIZE.large)};
    column-gap: ${gutter(SIZE.large)};
    
    ${({ $verticalSpace }) => $verticalSpace && `row-gap:${$verticalSpace === "large" ? unit(20) : $verticalSpace === "medium" ? unit(10) : unit(5)}`};
    margin-bottom: ${({ $removeSpaceAfter, $removeExtraSpaceAfter }) => $removeSpaceAfter ? $removeExtraSpaceAfter ? unit(-40) : unit(-20) : `0`};
  }

  ${mediaQuery[SIZE.xlarge]} {
    padding-left: ${margin(SIZE.xlarge)};
    padding-right: ${margin(SIZE.xlarge)};
    column-gap: ${gutter(SIZE.xlarge)};
  }

  ${mediaQuery[SIZE.max]} {
    padding-left: ${margin(SIZE.max)};
    padding-right: ${margin(SIZE.max)};
    column-gap: ${gutter(SIZE.max)};
  }
`;

export const StyledSeperator = styled.svg`
  margin-top: ${unit(10)};
  margin-left: auto;
  margin-right: auto;
  display: block;

  ${mediaQuery[SIZE.medium]} {
    margin-top: ${unit(20)};
  }
`